// removed by extract-text-webpack-plugin
module.exports = {"digest":"src-templates----digest-module---digest---19oHI","meta":"src-templates----digest-module---meta---1acSt"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/digest.module.scss
// module id = 256
// module chunks = 48551294870412